import { ExternalLink } from 'lucide-react'
import { Chip } from '../ds/index'
import { Icon } from './Icon'
import { ago } from '../lib/format'

/**
 * A post as its notification email carried it. The words, the group, when.
 * Deliberately not styled as Facebook: it is what we read, not a capture of the site.
 */
export function PostCard({ groupName, author, text, truncated, at, url, copies, children, byHand }: {
  groupName: string | null; author: string | null; text: string | null; truncated: boolean
  at: string; url: string | null; copies?: number; children?: React.ReactNode
  /** Made by a responder from screenshots: there was never an email, so no link is expected. */
  byHand?: boolean
}) {
  return (
    <article className="post-card">
      <div className="post-meta">
        <strong>{groupName || 'Unknown group'}</strong>
        <span>{author || 'A member'}</span>
        <span title={new Date(at).toLocaleString()}>{ago(at)}</span>
        {copies && copies > 1 ? <span>{copies} notifications</span> : null}
      </div>
      {text ? <p className="post-body">{text}</p> : <p className="post-body muted">The text of this post has been deleted under the retention policy.</p>}
      {truncated && <div className="post-cut">The email cut this post off. Read the rest on Facebook.</div>}
      <div className="post-actions">
        {url ? (
          <a className="btn btn-secondary" href={url} target="_blank" rel="noopener noreferrer">
            <Icon of={ExternalLink} size={15} /> Open on Facebook
          </a>
        ) : byHand ? <Chip>From your screenshots</Chip> : <Chip tone="warn">No link in the email</Chip>}
        {children}
      </div>
    </article>
  )
}
